import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
} from "antd";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import {
  GET_TRAINING_CATEGORY,
  GET_TRAINING_TEMPLATE,
} from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import httpService from "services/httpService";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { CommonButton } from "components/Common/ButtonCommon";
import TextArea from "antd/lib/input/TextArea";
import UploadImage from "components/Common/UploadImage";
import { uploadImg } from "helpers/erp_helper";
import { CommonDatePicker } from "components/Common/inputCommon";
import moment from "moment";
import { isEmpty } from "lodash";

const { RangePicker } = CommonDatePicker;

export default function NewTrainingTemplate() {
  const { id } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [trainingCategory, setTrainingCategory] = useState([]);
  const [sessionNumType, setSessionNumType] = useState("buổi học");
  const [image, setImage] = useState([]);

  useEffect(() => {
    getTrainingCategory();
    getTrainingTemplateDetail();
  }, [id]);

  const getTrainingTemplateDetail = async () => {
    if (!id) return;

    const res = await httpService.get(
      `${GET_TRAINING_TEMPLATE}/${id}?include=trainingCategory`
    );

    if (!res) {
      history.replace("/training-template");
      toastrErrorAlert("Training template not found!");
      return;
    }

    setImage({
      ...res.thumbnail,
      url: res?.thumbnail?.url.replace("phl.vvs.vn", "phl.live1.vn"),
    });
    setSessionNumType(res.sessionNumType);
    form.setFieldsValue({
      ...res,
      ...(res.startTime &&
        res.endTime && {
          time: [moment(res.startTime?.iso), moment(res.endTime?.iso)],
        }),
      trainingCategory: res.trainingCategory.objectId,
      ...(res?.descriptionList?.length > 0 && {
        descriptionList: res.descriptionList?.map(item => {
          return {
            description: item,
          };
        }),
      }),
    });
  };

  const getTrainingCategory = async () => {
    try {
      const res = await httpService.get(`${GET_TRAINING_CATEGORY}`);
      const trainingCategoryMap = res.results.map(item => {
        return {
          label: item.title,
          value: item.objectId,
        };
      });

      setTrainingCategory(trainingCategoryMap);
    } catch (error) {
      toastrErrorAlert("Get Training category fail!");
    }
  };

  const onSubmit = async values => {
    let thumbnail = [];

    if (image?.formattedSize && image?.length !== 0 && !image?.isRemove) {
      const res = await uploadImg(image);
      thumbnail.push(res);
    }

    const { time, ...rest } = values;

    const body = {
      ...rest,
      ...(values?.descriptionList?.length > 0 && {
        descriptionList: values.descriptionList.map(item => item.description),
      }),
      trainingCategory: {
        objectId: values.trainingCategory,
        __type: "Pointer",
        className: "TrainingCategory",
      },
      ...(thumbnail.length !== 0 && { thumbnail: { ...thumbnail[0] } }),
      ...((image?.isRemove || isEmpty(image)) && {
        thumbnail: { __op: "Delete" },
      }),
      ...(time
        ? {
            startTime: {
              __type: "Date",
              iso: time[0],
            },
            endTime: {
              __type: "Date",
              iso: time[1],
            },
          }
        : {
            startTime: {
              __op: "Delete",
            },
            endTime: {
              __op: "Delete",
            },
          }),
    };

    if (id) {
      await httpService.put(`${GET_TRAINING_TEMPLATE}/${id}`, body);
      toastrSuccessAlert("Cập nhật chương trình huấn luyện thành công!");
      return;
    }
    const res = await httpService.post(GET_TRAINING_TEMPLATE, body);
    toastrSuccessAlert("Thêm chương trình huấn luyện thành công!");
    history.replace(`/training-template/${res.objectId}`);
  };

  const disabledDate = current => {
    return current && current < moment().endOf("day");
  };

  return (
    <div className="page-content">
      <Form
        name="dynamic_form_nest_item"
        onFinish={onSubmit}
        autoComplete="off"
        layout="vertical"
        form={form}
        initialValues={{
          titleFontSize: 40,
          sessionNumType: "buổi học",
        }}
      >
        <HeaderCreateItem title={"Mẫu chương trình huấn luyện"}>
          <Form.Item>
            <CommonButton level={0} htmlType="submit">
              Lưu
            </CommonButton>
          </Form.Item>
        </HeaderCreateItem>
        <Row
          gutter={24}
          style={{
            margin: "5px 15rem",
          }}
        >
          <Col className="gutter-row" span={12}>
            <Form.Item
              label="Chương trình"
              name="trainingCategory"
              rules={[
                { required: true, message: "Vui lòng chọn chương trình" },
              ]}
            >
              <Select options={trainingCategory} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Số thứ tự hiển thị" name="order">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} style={{ justifyContent: "center" }}>
          <Col span={8}>
            <Form.Item name="image">
              <UploadImage onUploaded={setImage} imgFile={image} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} style={{ justifyContent: "center" }}>
          <Col className="gutter-row" span={8}>
            <Form.Item label="Tiêu đề ảnh" name="thumbnailTitle">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} style={{ justifyContent: "center" }}>
          <Col className="gutter-row" span={8}>
            <Form.Item label="Link video" name="videoUrl">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} style={{ justifyContent: "center" }}>
          <Col className="gutter-row" span={8}>
            <Form.Item label="Tiêu đề video" name="videoTitle">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row
          gutter={24}
          style={{
            border: "1px solid orange",
            margin: "5px 15rem",
            background: "#f9d28a",
            borderRadius: "7px",
            paddingTop: "10px",
          }}
        >
          <Col className="gutter-row" span={5}>
            <Form.Item
              label="Code"
              name="code"
              rules={[{ required: true, message: "Vui lòng nhập code" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Kích thước của code" name="titleFontSize">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={11}>
            <Form.Item
              label="Tiêu đề (vi)"
              name="title_vi"
              rules={[{ required: true, message: "Vui lòng nhập tiêu đề" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Tiêu đề (en)" name="title_en">
              <Input />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Row>
              <Col className="gutter-row" span={8}>
                <Form.Item label={`Số ${sessionNumType}`} name="sessionNum">
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={12}>
                <Form.Item label="Loại" name="sessionNumType">
                  <Select
                    onSelect={value => setSessionNumType(value)}
                    defaultValue="buổi học"
                    options={[
                      { label: "buổi học", value: "buổi học" },
                      { label: "chuyên đề", value: "chuyên đề" },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row
          style={{
            margin: "5px 15rem",
          }}
        >
          <Col className="gutter-row" span={24}>
            <Form.Item label="Mục tiêu khoá học" name="goal">
              <Input />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <p className="font-weight-bold">Mô tả</p>
            <Form.List name="descriptionList" label="Danh sách">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <SpaceStyled
                      key={key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                        width: "100%",
                      }}
                      align="baseline"
                    >
                      <Form.Item
                        {...restField}
                        name={[name, "description"]}
                        rules={[
                          { required: true, message: "Vui lòng nhập mô tả" },
                        ]}
                      >
                        <Input
                          placeholder="Nhập mô tả"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </SpaceStyled>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Thêm mô tả
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item label="Thời gian" name="time">
              <RangePicker
                disabledDate={disabledDate}
                showTime={{
                  hideDisabledOptions: true,
                }}
                format="DD-MM-YYYY HH:mm"
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item label="Địa điểm" name="place">
              <Input />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item label="Link nội dung khoá học" name="detailUrl">
              <InputStyled />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

const SpaceStyled = styled(Space)`
  .ant-space-item {
    width: 100%;
  }
`;

const InputStyled = styled(Input)`
  background: #ff6363;
  border-radius: 7px;
  color: white;
  border-color: unset;
`;
